import _ from "lodash";

const TOKEN_QUERY_PARAM = /([?&#]token=)[^&#\s"']*/g;

export const maskTokenInText = (text) => text.replace(TOKEN_QUERY_PARAM, "$1***");

export const maskQuickLinkToken = (event) =>
  event && _.cloneDeepWith(event, (value) => (_.isString(value) ? maskTokenInText(value) : undefined));
